import { useEffect, useState, useCallback } from "react";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import InvoicesTable from "../Components/Invoices/InvoicesTable";
import invoiceService from "../Services/invoiceService";
import { useAuth } from "../Auth/AuthContext";
import PublisherInvoicesTable from "../Components/Invoices/PublisherInvoicesTable";

export default function PublisherInvoicesPage() {
  const { user } = useAuth();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // ✅ Fetch invoices only for this publisher
  const fetchInvoices = useCallback(async () => {
    setIsLoading(true);
    try {
      if (user?.publisherId) {
        const result = await invoiceService.getByPublisher(user.publisherId);
        setData(result);
      }
    } catch {
      toast.error("Failed to fetch invoices");
    } finally {
      setIsLoading(false);
    }
  }, [user?.publisherId]);

  useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);

  // ✅ Only allow viewing/downloading invoice
  const handleViewInvoice = async (row) => {
    await invoiceService.downloadInvoice(row.id);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="p-4 sm:p-6 space-y-6"
    >
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">
          My Invoices
        </h1>
      </div>

      <PublisherInvoicesTable
        data={data}
        downloadInvoice={handleViewInvoice}
        isLoading={isLoading}
        // 🚫 No edit, delete, or status change props
        onEdit={null}
        onDelete={null}
        onStatusChange={null}
      />
    </motion.div>
  );
}
